<div class="workflow-template-container">
    <div class="header-bar" [attr.data-automation-id]="automationId + '-header-container'">
        <span>Workflows</span>
        <button type="button" class="help-button" [attr.data-automation-id]="automationId + '-help-button'"
            (click)="openHelp()">
            <i class="fa fa-question"></i>
        </button>
    </div>
    <res-generic-grid [gridName]="gridName" [automationId]="automationId" [helpIndex]="helpIndex" [columnDefs]="columnDefs"
        [requestInfo]="requestInfo" [contextMenuOptions]="contextMenuOptions" [rowsHaveGrouping]="true" [onCellClicked]="onCellClicked"  [customGridClass]="'ag-workflow-row'"
        [responseArrayCallback]="responseArrayCallback" [pagerVisible]="false" [responseCallback]="responseCallback" [loadDataFinishedCallback]="loadDataFinishedCallback">
    </res-generic-grid>
</div>
